export function useGroupDataByID(dataSaidas) {
  const groupedData = dataSaidas.reduce((acc, produto) => {
    const key = produto.produtoWinthor; // Assuming 'id' is the unique identifier for grouping
    const atualData = parsePtBrDate(produto.data);
    if (!acc[key]) {
      acc[key] = {
        ...produto,
        quantidade: 0,
        data: atualData,
        data_final: atualData,
      };
    }
    acc[key].quantidade += produto.quantidade;

    if (atualData < acc[key].data) {
      acc[key].data = atualData;
    }

    if (atualData > acc[key].data_final) {
      acc[key].data_final = atualData;
    }
    return acc;
  }, {});
  return groupedData;
}

function parsePtBrDate(str) {
  const [dia, mes, ano] = str.split('/');
  return new Date(ano, mes - 1, dia);
}

export function formatarDataBR(data) {
  const dia = String(data.getDate()).padStart(2, '0');
  const mes = String(data.getMonth() + 1).padStart(2, '0'); // mês começa em 0
  const ano = data.getFullYear();
  return `${dia}/${mes}/${ano}`;
}
